import Axios from "axios";
import {getHost} from "./ApiRequest";
import {ApiError} from "./ApiError";

const getVariables = org => {
    let route = "/info/envVariables/default";
    if (org) route = `/info/envVariables/${org}`;
    return Axios.get(getHost() + route)
    .then(response => {
        return Promise.resolve(response.data);
    }).catch(err => {
        return Promise.reject(new ApiError(err));
    });
};

export {getVariables};
